import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Gauge, MapPin, MessageSquare, Users } from 'lucide-react';
import { Seo } from '../components/Seo';
import { BUSINESS } from '../data/site';
import { SPEED_SCHOOL } from '../data/programs';
import { CHECKOUT } from '../data/checkout';
export function SpeedSchool() {
  return <div className="w-full bg-white" data-id="element-947" data-mp="ychaemj5syue">
      <Seo title="Speed School September 12 and 26 | Reach Performance McKinney" description="Two Saturday speed sessions in McKinney, TX on September 12 and 26, 9:30 to 11:00 AM. Coached sprint training plus speed and force plate testing. 15 athletes max. Reserve online." path="/speed-school" data-id="element-948" data-mp="1mqhgrqinjqp" />
      <Hero data-id="element-949" data-mp="feermph7fy51" />
      <Details data-id="element-950" data-mp="ff6lnvv5lnt7" />
      <WhatYouGet data-id="element-951" data-mp="ffpt2in6gtsz" />
      <ReserveBand data-id="element-952" data-mp="fg9ewafy82ca" />
    </div>;
}
function Hero() {
  return <section className="relative overflow-hidden bg-reach-black py-16 md:py-20" data-id="element-953" data-mp="3f0v69cvhuxnv">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-954" data-mp="3j2ge2jt68lr7">
        <div className="absolute top-1/4 -left-40 h-1.5 w-[45%] -rotate-[6deg] bg-reach-red opacity-40" data-id="element-955" data-mp="1kwhf9eku9t4o" />
        <div className="absolute top-[40%] -left-40 h-1.5 w-[30%] -rotate-[6deg] bg-reach-red opacity-25" data-id="element-956" data-mp="1fx4j2382v9pf" />
      </div>
      <div className="relative z-10 mx-auto grid max-w-container grid-cols-1 items-center gap-10 px-4 md:px-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-957" data-mp="1b5w8h3v0hiao">
        <div data-id="element-958" data-mp="1660ezyjxx99d">
          <p className="mb-5 font-inter text-xs font-semibold uppercase tracking-[0.25em] text-reach-red-light md:text-sm" data-id="element-959" data-mp="118i4w4u6snzs">
            {SPEED_SCHOOL.eyebrow}
          </p>
          <h1 className="mb-6 font-bebas text-[52px] leading-[0.92] tracking-wide text-white sm:text-6xl md:text-7xl lg:text-[84px]" data-id="element-960" data-mp="x99dh6mmd27e">
            Speed Training
            <br data-id="element-961" data-mp="na0l2i7ejvn5" />
            and Testing
          </h1>
          <p className="mb-8 max-w-xl font-inter text-lg leading-relaxed text-white md:text-xl" data-id="element-962" data-mp="2mm2zvf5301uh">
            {SPEED_SCHOOL.summary}
          </p>

          <dl className="mb-9 grid max-w-lg grid-cols-2 gap-x-6 gap-y-5 border-t border-white/15 pt-7" data-id="element-963" data-mp="2hobbgv3naxv1">
            <div data-id="element-964" data-mp="fx2i2x9wwwez">
              <dt className="mb-1 font-inter text-xs uppercase tracking-[0.2em] text-white/60" data-id="element-965" data-mp="fwj57uz4cy7t">
                Both sessions
              </dt>
              <dd className="font-bebas text-4xl leading-none tracking-wide text-white" data-id="element-966" data-mp="606en5yvf0ha">$125</dd>
            </div>
            <div data-id="element-967" data-mp="axy47tc1maib">
              <dt className="mb-1 font-inter text-xs uppercase tracking-[0.2em] text-white/60" data-id="element-968" data-mp="aziz5k29rvgp">
                Drop-in
              </dt>
              <dd className="font-bebas text-4xl leading-none tracking-wide text-white" data-id="element-969" data-mp="ymhbq6n9qj9c">$75</dd>
            </div>
          </dl>

          <div className="flex max-w-md flex-col items-stretch gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-970" data-mp="oqnwugm2udoe">
            <a href={CHECKOUT.speedSchoolBoth} className="btn-primary sm:w-auto" data-id="element-971" data-mp="to7jo4wubyry">
              Reserve Both Sessions · $125
            </a>
            <a href={CHECKOUT.speedSchoolSingle} className="btn-secondary-dark sm:w-auto" data-id="element-972" data-mp="39ihndxqx82rx">
              Single Session · $75
            </a>
          </div>
          <p className="mt-5 font-inter text-sm text-white/70" data-id="element-973" data-mp="1wgs5zm0ptwzi">
            Secure checkout by Stripe. Prefer to reserve by text?{' '}
            <a href={BUSINESS.smsHref} className="inline-flex items-center gap-1 font-semibold text-white underline hover:text-reach-red-light" data-id="element-974" data-mp="1rkuovdhmomlo">
              <MessageSquare size={14} aria-hidden="true" data-id="element-975" data-mp="21gelk240npbh" />
              Text {BUSINESS.phoneDisplay}
            </a>
          </p>
        </div>

        <figure className="m-0" data-id="element-976" data-mp="1drlk5q4mkp9h">
          <img src={SPEED_SCHOOL.flyer} alt="Reach Performance Speed School flyer showing an athlete sprinting, with sessions on Saturdays September 12 and 26 from 9:30 to 11:00 AM at INPOWERiQ in McKinney" className="w-full rounded-[4px] border border-white/10" loading="lazy" decoding="async" data-id="element-977" data-mp="18s8u6wigj22o" />
          <figcaption className="mt-3 font-inter text-xs italic text-white/60" data-id="element-978" data-mp="u1jlq1wds12i">
            All flyer details are listed as text on this page.
          </figcaption>
        </figure>
      </div>
    </section>;
}
function Details() {
  const details = [{
    Icon: Calendar,
    label: 'Dates and time',
    value: 'Saturdays, September 12 and 26, 9:30 to 11:00 AM'
  }, {
    Icon: Users,
    label: 'Group size',
    value: SPEED_SCHOOL.cap
  }, {
    Icon: MapPin,
    label: 'Location',
    value: SPEED_SCHOOL.location
  }];
  return <section className="bg-white py-16 md:py-20" data-id="element-979" data-mp="1meg1d3k6hxcc">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-980" data-mp="1qgb3ga9xoer6">
        <h2 className="sr-only" data-id="element-981" data-mp="1qernkks6w5px">Speed School details</h2>
        <dl className="grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-982" data-mp="1vfe9ny1ngr0q">
          {details.map(({
          Icon,
          label,
          value
        }) => <div key={label} className="border-l-4 border-reach-red bg-reach-gray p-6 md:p-7" data-id="element-983" data-mp="20dfsqiz2sqc7">
              <dt className="mb-3 flex items-center gap-2 font-inter text-xs font-semibold uppercase tracking-[0.22em] text-reach-black/60" data-id="element-984" data-mp="12y4z1oi5kxz">
                <Icon size={16} className="text-reach-red" aria-hidden="true" data-id="element-985" data-mp="62khta0f4z69" />
                {label}
              </dt>
              <dd className="font-inter text-lg font-semibold leading-snug text-reach-black" data-id="element-986" data-mp="3pw5txgfssc27">
                {value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}
function WhatYouGet() {
  const items = ['Coached sprint training across two Saturday sessions.', 'Full speed testing on timing gates.', 'Force plate testing for jump and landing output.', 'A written summary of the numbers your athlete produced.'];
  return <section className="bg-reach-gray py-16 md:py-20" data-id="element-987" data-mp="7hwqlath2dhg">
      <div className="mx-auto max-w-3xl px-4 md:px-8" data-id="element-988" data-mp="7gbtpejoqigf">
        <div className="mb-8 text-center" data-id="element-989" data-mp="2jbm2z76t7n7">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-990" data-mp="2iadr2hk2z96">
            What Your Athlete Leaves With
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-5xl" data-id="element-991" data-mp="2n8rkogcne0ne">Real Numbers</h2>
        </div>
        <ul className="grid grid-cols-1 gap-4 border-l-4 border-reach-red bg-white p-6 md:grid-cols-2 md:p-8" data-id="element-992" data-mp="1f9c4ojdalal9">
          {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-993" data-mp="1j930j1hoegwn">
              <Gauge size={18} className="mt-0.5 shrink-0 text-reach-red" aria-hidden="true" data-id="element-994" data-mp="15acugwcvp6w5" />
              <span className="font-inter text-base text-reach-black" data-id="element-995" data-mp="1a9fyqel1b932">{item}</span>
            </li>)}
        </ul>
        <p className="mt-8 text-center font-inter text-base text-reach-black/75" data-id="element-996" data-mp="vk1qj9t72xp9">
          Training in the fall season as well?{' '}
          <Link to="/programs" className="font-semibold text-reach-black underline hover:text-reach-red" data-id="element-997" data-mp="mkwr819t70c1">
            See the fall programs and class times
          </Link>
          .
        </p>
      </div>
    </section>;
}
function ReserveBand() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-998" data-mp="cna812lh8mm9">
      <div className="mx-auto max-w-container px-4 text-center md:px-8" data-id="element-999" data-mp="hmd2xu7qtcgi">
        <h2 className="mb-4 font-bebas text-5xl tracking-wide text-white md:text-6xl" data-id="element-1000" data-mp="hno920onuwas">
          Reserve a Speed School Spot
        </h2>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-lg text-white md:text-xl" data-id="element-1001" data-mp="3q4m6u1pkb35m">
          {SPEED_SCHOOL.cap}. Reserve online in a few taps, or text {BUSINESS.phoneDisplay} to hold a
          place.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-1002" data-mp="2ycyhp8b7lhf">
          <a href={CHECKOUT.speedSchoolBoth} className="inline-flex min-h-[44px] items-center justify-center rounded-[4px] bg-white px-6 font-inter text-sm font-semibold uppercase tracking-wide text-reach-black transition-all duration-200 ease-out hover:-translate-y-[3px] hover:bg-reach-black hover:text-white md:min-h-[48px] md:text-base" data-id="element-1003" data-mp="gwjh5y4otewi">
            Reserve Both · $125
          </a>
          <a href={CHECKOUT.speedSchoolSingle} className="btn-secondary-dark sm:w-auto" data-id="element-1004" data-mp="vo21270o3tl5">
            Single Session · $75
          </a>
        </div>
      </div>
    </section>;
}